import React from 'react'
import type { FC } from 'react'
import { Collapsable } from './collapsable.js'
import { CoreBlock } from './core-block.js'
import type { CoreBlockProps } from './core-block.js'
import { DndBlock } from './dnd-block.js'

export interface BlockProps extends Omit<CoreBlockProps, 'dragRef' | 'blockRef' | 'dropLine' | 'isDragging'> {
  draggable?: boolean
  collapsable?: boolean
  defaultExpanded?: boolean
}

const BlockFragment = ({ children }: { children: React.ReactNode; title?: React.ReactNode }) => (
  <React.Fragment>{children}</React.Fragment>
)

export const Block: FC<BlockProps> = props => {
  const { draggable = true, collapsable = false, defaultExpanded, title, ...restProps } = props

  const Container = collapsable ? Collapsable : BlockFragment

  return (
    <Container title={title} defaultExpanded={defaultExpanded}>
      {draggable ? <DndBlock {...restProps} title={title} /> : <CoreBlock {...restProps} title={title} />}
    </Container>
  )
}
